// Export extra function
export function extra() {
  console.log("Hello from extra component!");
  const links: NodeListOf<HTMLAnchorElement> = document.querySelectorAll("a");
  const lastLink: HTMLAnchorElement | undefined = Array.from(links).at(-1);

  if (lastLink) {
    lastLink.remove();
  }
}
